import {Directive, Input, ElementRef, OnChanges, SimpleChanges, OnInit} from '@angular/core';

@Directive({
    selector: '[ui-spinner]'
})

export class UiSpinner implements OnChanges , OnInit{
    constructor(private el: ElementRef) {}

    @Input() show: boolean;
    @Input() type: string;

    ngOnInit(){
        if (this.show) {
            this.el.nativeElement.className = 'spinner spinner-' + this.type;
        }
    }
    ngOnChanges(changes: SimpleChanges){
        if (this.show) {
            this.el.nativeElement.className = 'spinner spinner-' + this.type;
        } else {
            this.el.nativeElement.className = '';
        }
    }
}